<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent" id="fm">Other books by the author:</p>
<p class="indent1"><em>Chess Not Checkers</em></p>
<p class="indent1"><em>The Heart of Leadership</em></p>
<p class="indent1"><em>The Secret of Teams</em></p>
<p class="indent1"><em>The Secret</em> with Ken Blanchard</p>
<p class="indent1"><em>Great Leaders Grow</em> with Ken Blanchard</p>
<p class="noindentt">Related Field Guides:</p>
<p class="indent1"><em>The Secret</em> with Randy Gravitt</p>
<p class="indent1"><em>Chess Not Checkers</em> with Randy Gravitt</p>
<p class="indent1"><em>The Heart of Leadership</em></p>
<p class="indent1"><em>The Secret of Teams</em><a id="page_iii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm.vue?11ef59d6